/* eslint-disable no-debugger */
import { distributorService } from '../../service/distributor.service';
import 'react-toastify/dist/ReactToastify.css';
import { getConstants, ProductConstants } from './actionType';

function DistributorList(page, searchValue, filterValue, sort) {
    function request(user) { return { type: getConstants.GET_DISTRIBUTORS_LIST_REQUEST, user }; }
    function success(user) { return { type: getConstants.GET_DISTRIBUTORS_LIST_SUCCESS, user }; }
    function failure(error) {
        return { type: getConstants.GET_DISTRIBUTORS_LIST_FAILURE, error };
    }
    return async (dispatch) => {
        dispatch(request());
        const dataList = await distributorService.DistributorList(page, searchValue, filterValue, sort);
        if (dataList.error) {
            dispatch(failure(dataList.message));
            return dataList;
        }
        dispatch(success(dataList));
        return dataList;
    };
}

function updateAdminUser(body, email) {
    function request(user) { return { type: getConstants.GET_PARTICULAR_REQUEST, user }; }
    function success(user) { return { type: getConstants.GET_PARTICULAR_SUCCESS, user }; }
    function failure(error) {
        return { type: getConstants.GET_PARTICULAR_FAILURE, error };
    }
    return async (dispatch) => {
        dispatch(request());
        const data = await distributorService.updateAdminUser(body, email);
        if (data.error) {
            dispatch(failure(data.message));
        }
        dispatch(success(data));
        return data;
    };
}
function SortDistributor(sortBody) {
    function request(user) { return { type: getConstants.GET_PARTICULAR_REQUEST, user }; }
    function success(user) { return { type: getConstants.GET_PARTICULAR_SUCCESS, user }; }

    return async (dispatch) => {
        dispatch(request());
        dispatch(success(sortBody));
        return sortBody;
    };
}
function AdminPaginationMethod(dataPagination, type) {
    function add(user) { return { type: getConstants.ADD_PAGINATION, user }; }
    function remove(user) { return { type: getConstants.REMOVE_PAGINATION, user }; }

    return async (dispatch) => {
        if (type === 'add') {
            dispatch(add(dataPagination));
        } else {
            dispatch(remove(dataPagination));
        }
        return dataPagination;
    };
}
function offerList(page, searchValue, filterValue, sort) {
    function request(user) { return { type: getConstants.GET_ALL_OFFER_REQUEST, user }; }
    function success(user) { return { type: getConstants.GET_ALL_OFFER_SUCCESS, user }; }
    function failure(error) {
        return { type: getConstants.GET_ALL_OFFER_FAILURE, error };
    }
    return async (dispatch) => {
        dispatch(request());
        const data = await distributorService.offerList(page, searchValue, filterValue, sort);
        if (data.error) {
            dispatch(failure(data.message));
            return data;
        }
        dispatch(success(data));
        return data;
    };
}
function AddadminSKUList(data) {
    function add(user) { return { type: getConstants.ADD_SKU_CATEGORY, user }; }
    // function remove(user) { return { type: getConstants.REMOVE_PAGINATION, user }; }

    return async (dispatch) => {
        dispatch(add(data));

        return data;
    };
}

function ProductListing(payload) {
    function request(user) { return { type: ProductConstants.GET_PRODUCTS_LIST_REQUEST, user }; }
    function success(user) { return { type: ProductConstants.GET_PRODUCTS_LIST_SUCCESS, user }; }
    function failure(error) {
        return { type: ProductConstants.GET_PRODUCTS_LIST_FAILURE, error };
    }
    return async (dispatch) => {
        dispatch(request());
        const data = await distributorService.GetProductList(payload);
        if (data.error) {
            dispatch(failure(data.message));
            return data;
        }
        dispatch(success(data));
        return data;
    };
}

function handleFiltersData(filter) {
    function success(user) { return { type: ProductConstants.GET_PRODUCTS_FILTERS_SUCCESS, user }; }

    return async (dispatch) => {
        dispatch(success(filter));
        return filter;
    };
}

export const DistributorActions = {
    DistributorList,
    updateAdminUser,
    SortDistributor,
    AdminPaginationMethod,
    offerList,
    AddadminSKUList,
    ProductListing,
    handleFiltersData,

};
